<div class="project-drop-zone"
  appDroppable
  [appDroppableHoverClass]="stitchDragActive() ? 'outline-2 outline-dashed outline-primary outline-offset-[-2px]' : ''"
  [appDroppableDisabled]="!project().id"
  [appDroppablePredicate]="incomingTaskPredicate"
  [appDroppableZIndex]="2"
  [appDroppableNoReposition]="true"
  (appDroppableDrop)="dndDrop($event)">
<div class="project-drop-content"
  appDroppable
  [appDroppableDisabled]="!project().id"
  [appDroppablePredicate]="dndPredicate"
  [appDroppableNoReposition]="true"
  (appDroppableDrop)="dndDrop($event)">
<div
  class="heading skin-detail-heading"
  (resize)="handleResize($event)"
  >
  @if (canGoBack()) {
    <app-button2
      appearance="secondary-ghost"
      size="s"
      aria-label="Go back"
      (click)="handleGoBack()"
      >
      <app-icon name="chevron-left" />
    </app-button2>
  }

  @if (project().progress >= 0) {
    <!-- stitch-app-shell TaskCheck: the 20px circle sits in a 24px box, 8px from the title. -->
    <app-circular-progress
      class="ml-1 mr-3"
      [progress]="project().progress"
      [size]="20"
      [priority]="form.controls.priority.value"
      [completed]="project().completed"
      (onClick)="handleComplete()"
      />
  }

  <app-input
    class="input"
    appearance="sapphire-inline"
    [inputFormControl]="form.controls.title"
    placeholder="New Project"
    [errorPlaceholder]="'Add title'"
    [withErrors]="submitted"
    size="s"
    />

    <div class="icons">
      <div [appPreventDirtyClick]="dirtyFormRef" class="contents">
        <!-- [MUST-002] 'Bug' debug quick-action hidden per task; uncomment to re-enable
        <stch-quick-action
          *ngIf="!contracted"
          appearance="sapphire-toggle"
          size="m"
          icon="bug"
          [active]="selectedTab === 'debug'"
          matTooltip="Debug"
          (onClick)="selectedTab = 'debug'"
          />
          -->

          <!-- [MUST-035B] 'Stitch To' button hidden per task; uncomment to re-enable
          <app-button2
            *ngIf="!contracted"
            appearance="secondary-ghost"
            size="xs"
            [disabled]="!project()?.id"
            matTooltip="Stitch to"
            [appStitchToPopover]="project()"
            >
            <app-icon name="sapphire-stitch" />
          </app-button2>
          -->

          @if (!contracted) {
            <stch-quick-action
              appearance="sapphire-toggle"
              size="m"
              icon="sapphire-archive2"
              [active]="form.controls.archived.value"
              [matTooltip]="form.controls.archived.value ? Labels.RestoreFromArchive : Labels.Archive"
              [disabled]="!project()?.id"
              (onClick)="archive()"
              />
          }

          @if (!contracted) {
            <stch-trash-action [deleted]="form.controls.deleted.value" [disabled]="!project()?.id" (onClick)="delete()" />
          }

          <!-- SBUX-785 v1: containers are not shareable (only leaf entities). Re-enable later.
          <stch-quick-action
            *ngIf="!contracted"
            appearance="sapphire-toggle"
            size="m"
            icon="sapphire-share"
            matTooltip="Share"
            [disabled]="!project()?.id"
            [stchShareContextMenu]="project()"
            [stchShareContextMenuDisabled]="!project()?.id"
            />
            -->

            <ng-container *ngComponentOutlet="workspaceComponents['app-item-workspace-chip']; inputs: workspaceChipInputs" />

            <app-button2
              appearance="secondary-ghost"
              size="xs"
              matTooltip="More options"
              ariaLabel="More options"
              [disabled]="!project()?.id"
              (appProjectContextMenuDetails)="selectedTab = 'details'"
              [appProjectContextMenuElementLocation]="UILocations.mainView"
              (appProjectContextMenuTab)="$event === 'versions' ? openVersionHistory() : selectedTab = $event"
              [appProjectContextMenu]="project()"
              [appProjectContextMenuDisabled]="!project()?.id"
              appProjectContextMenuMode="popover"
              [printEnabled]="true"
              >
              <app-icon name="sapphire-ellipsis" />
            </app-button2>
          </div>

          @if (showCloseButton) {
            <app-button2
              appearance="secondary-ghost"
              size="xs"
              aria-label="Close"
              (click)="handleClose()"
              >
              <app-icon name="sapphire-close" />
            </app-button2>
          }
        </div>
      </div>

      @if (!project().id && workspaceIdentity(); as identity) {
        <app-tenancy-selector
          [spaceTitle]="identity.spaceTitle"
          [spaceTenantId]="identity.spaceTenantId"
          [memberTenantId]="identity.memberTenantId"
          itemNoun="project"
          [locked]="form.controls.uploads.value.length > 0"
          [(tenantId)]="sharingTenantId"
        />
      }

      <!--
        stitch-app-shell DetailPanel header: the dates are the line under the title (12px Gray/600, starting under
        it), and the Knowledge button sits at the end of the tab row, as on a task.
      -->
      <!-- A new project has no dates line: its "n/a" and bare "Created: | Updated:" only pushed the tabs down
           (Johanna, 2026-10-21: creation modals keep the title close to the tabs). -->
      <div class="project-header-meta">
        @if (project()?.id) {
          <!-- As the task header (Johanna, 2026-10-21): "Start Oct 1 | Due Dec 15", each opening the date picker. -->
          <stch-header-dates
            [fromDate]="form.controls.fromDate"
            [fromTime]="form.controls.fromTime"
            [toDate]="form.controls.toDate"
            [toTime]="form.controls.toTime"
            [overdue]="isOverdue()"
          />
        }
        <!-- Last, so its empty host on personal items adds no gap before the dates. -->
        <ng-container *ngComponentOutlet="workspaceComponents['app-item-team-label']; inputs: workspaceLabelInputs" />
      </div>

      <div class="skin-detail-tabs flex flex-row items-center h-[42px] gap-3 px-4 border-b border-gray-200">
        <app-tabs appearance="sapphire" [values]="workspaceTabs" [(value)]="selectedTab" size="m" />

        <div class="flex-1"></div>

        <stch-knowledge-button [active]="displayKnowledge" (click)="showKnowledge()" />
      </div>

      @if (selectedTab === 'stitch' && hasKnowledgeHubAccess()) {
        <app-entity-hub-search [contactId]="project()?.id" />
      }

      <div class="knowledge-sections">
        <!-- One Knowledge box, rows in the skin's order: Knots · Tags · Connections. On the Stitch tab the rows are
             the knowledge hub's facets (#2481), read-only, and hidden without hub access. -->
        <div
          class="form-knowledge"
          [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
        >
          <app-knots
            class="form-knots"
            [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
            [stitchItems]="project() | toArray"
            [control]="form.controls['knots']"
            [stateKey]="StateKey.knotsList"
            [withControls]="selectedTab !== 'stitch'"
            [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
            [hubEntityUid]="project()?.id"
          />

          <app-tags
            class="form-tags"
            [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
            [stitchItems]="[project()]"
            [control]="form.controls['tags']"
            [stateKey]="StateKey.tagsList"
            [withControls]="selectedTab !== 'stitch'"
            [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
            [hubEntityUid]="project()?.id"
          />

          <app-connections
            class="form-knots"
            [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
            [stitchItems]="[project()]"
            [control]="form.controls['connections']"
            [stateKey]="StateKey.connectionsList"
            [withControls]="selectedTab !== 'stitch'"
            [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
            [hubEntityUid]="project()?.id"
          />
        </div>
            </div>

            @if (form) {
              <div
                class="bg-white flex flex-1 flex-col relative overflow-y-hidden"
                appDroppable
                [appDroppableDisabled]="!stitchItem?.id"
                [appDroppablePredicate]="dndPredicate"
                (appDroppableDrop)="dndDrop($event)"
                [appDroppableZIndex]="0"
                >
                <div
                  class="absolute z-[1] inset-1 rounded-md"
                  [class.hidden]="!stitchDragActive()"
                  style="
                    background-image: url(&quot;data:image/svg+xml;utf8,<svg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill: none; stroke: rgb(172,213,255); stroke-width: 4; stroke-dasharray: 15 11'/></svg>&quot;);
                  "
                ></div>

                <!-- The row holds the Tasks tab's view menu and the Stitch filters; on the other tabs it
                     would only open a gap between Knowledge and the tab's content (Johanna, 2026-10-21). The
                     Knowledge Hub's Stitch view brings its own. -->
                <div
                  class="flex justify-end items-center pt-8 pb-5 px-8"
                  [class.hidden]="!headingRowShown() || (selectedTab === 'stitch' && hasKnowledgeHubAccess())"
                >
                  <div class="form-heading">
                    <div class="form-heading-nav mx-2 h-8">
                      <div class="form-heading-nav-separator"></div>

                        @if (selectedTab === 'stitch' && permissionsLoaded() && !hasKnowledgeHubAccess()) {
                          <app-context-menu-state-indicator
                            class="form-heading-nav-state"
                            svgIcon="filters"
                            appStitchListContextMenu
                            (appStitchListContextMenuChange)="stitchListState = $event"
                            />
                          }

                          </div>

                          @if (displayKnowledge) {
                            <div class="form-heading-nav-underline"></div>
                          }
                        </div>

                        @if (selectedTab === 'project') {
                          <!-- main's view menu: the current view with its icon, Board view / List view inside. -->
                          <div class="flex items-center justify-end gap-2">
                            <app-dropdown-input
                              appearance="sapphire-outline"
                              size="m"
                              [options]="viewModeOptions"
                              [value]="viewMode()"
                              (onChange)="viewMode.set($event)"
                            />
                          </div>
                          }
                        </div>

                        @if (headingRowShown()) {
                          <hr class="px-8" [class.hidden]="selectedTab === 'stitch' && hasKnowledgeHubAccess()" />
                        }

                        @if ((selectedTab !== 'stitch' || (permissionsLoaded() && !hasKnowledgeHubAccess()))) {
                          <app-scroll class="form-scroll" (top)="displayScrollShadow = !$event">
                            @if (displayScrollShadow) {
                              <div class="form-scroll-shadow"></div>
                            }

                            @switch (selectedTab) {
                              @case ('project') {
                                @if (viewMode() === 'list') {
                                  <app-project-tasks-list
                                    [project]="project()"
                                    [projectId]="project()?.id"
                                    [filters]="tasksFilters"
                                    (openTask)="handleClickItem($event)"
                                    (openSubtask)="handleClickItem($event)"
                                    (clickTask)="handleClickItem($event)"
                                    (doubleClickTask)="handleDblClickItem($event)"
                                    />
                                  }

                                  @if (viewMode() === 'board') {
                                    <app-project-board [project]="project()" />
                                  }
                                }

                                @case ('details') {
                                  <!-- stitch-app-shell FormKit (ContainerForm, project): Start · Due and Priority, Reminders, then the description. -->
                                  <div class="form-kit" [class.contracted]="contracted">
                                    <section class="form-kit-section">
                                      <!-- Priority beside Start · Due, narrower than a date (Johanna, 2026-10-21). -->
                                      <div class="form-kit-row">
                                        <app-date-range-picker
                                          class="form-kit-field-range"
                                          startLabel="Start date"
                                          endLabel="Due date"
                                          separator="none"
                                          [fromDate]="form.controls.fromDate"
                                          [toDate]="form.controls.toDate"
                                          [fromTime]="form.controls.fromTime"
                                          [toTime]="form.controls.toTime"
                                          [overdue]="isOverdue()"
                                        />

                                        <div class="form-kit-field form-kit-field-narrow">
                                          <span class="form-kit-label">Priority</span>
                                          <app-dropdown-input
                                            size="m"
                                            [inputFormControl]="form.controls.priority"
                                            [options]="priorityOptions"
                                            [appearance]="'sapphire-outline'"
                                            [icon]="selectedPriorityIcon()"
                                          />
                                        </div>
                                      </div>

                                      <!--This section is hidden for V1-->
                                      @if (false) {
                                        <div class="form-kit-field">
                                          <span class="form-kit-label">Issue Key</span>
                                          <app-input
                                            appearance="sapphire-outline"
                                            [inputFormControl]="form.controls.issueKey"
                                            placeholder="Issue Key"
                                            [withErrors]="submitted"
                                            [withClear]="true"
                                            size="s"
                                          />
                                        </div>
                                      }
                                    </section>

                                    <section class="form-kit-section form-kit-section-compact">
                                      <h3 class="form-kit-section-title">Reminders</h3>
                                      <stch-reminders-picker anchors="task" [control]="form.controls.reminders" />
                                    </section>

                                    <section class="form-kit-section">
                                      <stch-item-description-field
                                        [control]="form.controls.description"
                                        [item]="project()"
                                        [tagsControl]="form.controls['tags']"
                                        [knotsControl]="form.controls['knots']"
                                      />

                                      @if (project()?.createdAt) {
                                        <app-stitch-timestamps
                                          class="form-kit-timestamps mt-4 block"
                                          [createdAt]="project()?.createdAt"
                                          [updatedAt]="project()?.updatedAt"
                                        />
                                      }
                                    </section>
                                  </div>
                                          }

                                          @case ('attachments') {
                                            @if (audienceResolved()) {
                                              <app-attachments-list
                                              class="form-attachments"
                                              [stitchItem]="stitchItem"
      [tenantItems]="uploadTenantItems()"
                                              [inputControl]="form.controls.uploads"
                                              [contextMenuStateVariant]="attachmentsMenuStateVariant"
                                              (listStateChange)="attachmentsListState = $event"
                                              (onClickItem)="handleClickItem($event)"
                                              (onDblClickItem)="handleDblClickItem($event)"
                                              (uploading)="onUploadingChange($event)"
                                              />
                                            }
                                            }

                                            @case ('stitch') {
                                              <app-linked-info-list
                                                class="form-linked-info"
                                                [stitch]="project()"
                                                [state]="stitchListState"
                                                [placeholderSubtitle]="project()?.id ? undefined : 'Save to start Stitching items'"
                                                (clickStitchItem)="handleClickItem($event)"
                                                (dblClickStitchItem)="handleDblClickItem($event)"
                                                />
                                              }

                                              @case ('versions') {
                                                @if (historyAvailable()) {
                                                  <ng-container *ngComponentOutlet="workspaceComponents['app-project-version-history']; inputs: versionHistoryInputs" />
                                                }
                                              }

                                              @case ('access') {
                                                <ng-container *ngComponentOutlet="workspaceComponents['app-item-workspace-access']; inputs: workspaceLabelInputs" />
                                              }

                                              @case ('comments') {
                                                <stch-comments class="form-linked-info" [stitch]="project()" [insideTeam]="insideTeam" />
                                              }

                                              @case ('debug') {
                                                <stch-json-viewer [json]="project()?.debug" />
                                              }
                                            }
                                          </app-scroll>
                                        }

                                        @if (selectedTab === 'stitch' && hasKnowledgeHubAccess()) {
                                          <app-stitch-hub
                                            [stitch]="project()"
                                            (clickStitchItem)="handleClickItem($event)"
                                            (dblClickStitchItem)="handleDblClickItem($event)"
                                          />
                                        }

                                        <stch-save-cancel-panel
                                          [enabled]="!pristine"
                                          [uploading]="isUploading()"
                                          [saveLabel]="saveLabel()"
                                          (onCancel)="handleCancel()"
                                          (onSave)="handleSubmit()"
                                          />

                                        </div>
                                      }

<!-- stitch-app-shell breadcrumbs footer in the main view, as on every detail page. -->
@if (navigation.enabled && stitchItem?.id) {
  <app-detail-breadcrumbs
    [crumbs]="breadcrumbs()"
    [status]="form.controls.archived.value ? 'Archived' : form.controls.deleted.value ? 'Trash' : undefined"
  />
} @else {
  <ng-container *ngComponentOutlet="workspaceComponents['app-item-workspace-footer']; inputs: workspaceFooterInputs" />
}
</div>
</div>
